import { render, staticRenderFns } from "./IP_RebuttalsByCoder.vue?vue&type=template&id=c31ed9f8&scoped=true&"
import script from "./IP_RebuttalsByCoder.vue?vue&type=script&lang=js&"
export * from "./IP_RebuttalsByCoder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31ed9f8",
  null
  
)

export default component.exports